import { ConsultaPreviaAnalise } from "./ConsultaPreviaAnalise";

export default ConsultaPreviaAnalise;